<template>
  <div class="sidebar" :class="{ 'dark-mode': isDarkMode, 'mobile-sidebar': isMobileView, 'sidebar-collapsed': isSidebarCollapsed }">
    <div class="sidebar-toggle mobile-only" @click="toggleSidebar">
      <i :class="isSidebarCollapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
    </div>
    
    <div class="sidebar-content">
      <div v-if="isTheoryRoute">
        <h3 class="sidebar-title">理论学习</h3>
        <el-menu
          :default-active="activeIndex"
          class="sidebar-menu"
          :background-color="isDarkMode ? '#1a1a2e' : '#f5f7fa'"
          :text-color="isDarkMode ? '#f0f0f0' : '#333'"
          :active-text-color="'#7957d5'"
          :collapse="isMobileView && isSidebarCollapsed"
          router
        >
          <el-menu-item index="/theory/intro">
            <i class="el-icon-info"></i>
            <span slot="title">什么是抖音SEO</span>
          </el-menu-item>
          <el-menu-item index="/theory/why">
            <i class="el-icon-question"></i>
            <span slot="title">为什么要做抖音SEO</span>
          </el-menu-item>
          <el-menu-item index="/theory/blueocean">
            <i class="el-icon-ship"></i>
            <span slot="title">抖音SEO是蓝海市场</span>
          </el-menu-item>
          <el-menu-item index="/theory/cases">
            <i class="el-icon-document"></i>
            <span slot="title">抖音SEO成功案例</span>
          </el-menu-item>
          <el-menu-item index="/theory/algorithm">
            <i class="el-icon-cpu"></i>
            <span slot="title">抖音SEO核心算法</span>
          </el-menu-item>
          <el-menu-item index="/theory/strategy">
            <i class="el-icon-s-operation"></i>
            <span slot="title">抖音SEO实施策略</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div v-if="isPracticeRoute">
        <h3 class="sidebar-title">实战指导</h3>
        <el-menu
          :default-active="activeIndex"
          class="sidebar-menu"
          :background-color="isDarkMode ? '#1a1a2e' : '#f5f7fa'"
          :text-color="isDarkMode ? '#f0f0f0' : '#333'"
          :active-text-color="'#7957d5'"
          :collapse="isMobileView && isSidebarCollapsed"
          router
        >
          <el-menu-item index="/practice/account">
            <i class="el-icon-user"></i>
            <span slot="title">账号搭建</span>
          </el-menu-item>
          <el-menu-item index="/practice/keywords">
            <i class="el-icon-search"></i>
            <span slot="title">选词与选蓝海词</span>
          </el-menu-item>
          <el-menu-item index="/practice/content">
            <i class="el-icon-video-camera"></i>
            <span slot="title">制作优质内容</span>
          </el-menu-item>
          <el-menu-item index="/practice/publish">
            <i class="el-icon-upload"></i>
            <span slot="title">优化发布策略</span>
          </el-menu-item>
          <el-menu-item index="/practice/analysis">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">数据分析与调整</span>
          </el-menu-item>
          <el-menu-item index="/practice/advanced">
            <i class="el-icon-star-on"></i>
            <span slot="title">进阶技巧与避坑指南</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div class="progress-section" v-if="!isSidebarCollapsed">
        <h3 class="sidebar-title">学习进度</h3>
        <div class="progress-container">
          <div v-if="isTheoryRoute">
            <div v-for="(value, key) in theoryProgress" :key="key" class="progress-item">
              <span class="progress-label">{{ getTheoryLabel(key) }}</span>
              <el-progress 
                :percentage="value * 100" 
                :color="progressColor"
                :stroke-width="8"
              ></el-progress>
            </div>
          </div>
          <div v-if="isPracticeRoute">
            <div v-for="(value, key) in practiceProgress" :key="key" class="progress-item">
              <span class="progress-label">{{ getPracticeLabel(key) }}</span>
              <el-progress 
                :percentage="value * 100" 
                :color="progressColor"
                :stroke-width="8"
              ></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SideNavigation',
  data() {
    return {
      isMobileView: false,
      isSidebarCollapsed: false
    }
  },
  computed: {
    ...mapGetters(['isDarkMode', 'getTheoryProgress', 'getPracticeProgress']),
    activeIndex() {
      return this.$route.path
    },
    isTheoryRoute() {
      return this.$route.path.includes('/theory')
    },
    isPracticeRoute() {
      return this.$route.path.includes('/practice')
    },
    theoryProgress() {
      return this.getTheoryProgress
    },
    practiceProgress() {
      return this.getPracticeProgress
    },
    progressColor() {
      return [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f42c1', percentage: 100}
      ]
    }
  },
  methods: {
    getTheoryLabel(key) {
      const labels = {
        intro: '什么是抖音SEO',
        why: '为什么要做抖音SEO',
        blueocean: '抖音SEO是蓝海市场',
        cases: '抖音SEO成功案例',
        algorithm: '抖音SEO核心算法',
        strategy: '抖音SEO实施策略'
      }
      return labels[key] || key
    },
    getPracticeLabel(key) {
      const labels = {
        account: '账号搭建',
        keywords: '选词与选蓝海词',
        content: '制作优质内容',
        publish: '优化发布策略',
        analysis: '数据分析与调整',
        advanced: '进阶技巧与避坑指南'
      }
      return labels[key] || key
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
      // 在移动视图下默认折叠侧边栏
      if (this.isMobileView) {
        this.isSidebarCollapsed = true;
      } else {
        this.isSidebarCollapsed = false;
      }
    }
  },
  mounted() {
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobileView);
  }
}
</script>

<style scoped>
.sidebar {
  width: 280px;
  background-color: #f5f7fa;
  transition: all 0.3s ease;
  overflow-y: auto;
  height: calc(100vh - 60px);
  position: relative;
}

.dark-mode.sidebar {
  background-color: #1a1a2e;
}

.sidebar-content {
  padding: 20px 0;
}

.sidebar-title {
  padding: 0 20px;
  margin-bottom: 15px;
  font-size: 18px;
  color: #7957d5;
}

.sidebar-menu {
  border-right: none !important;
}

.progress-section {
  margin-top: 30px;
  padding: 0 20px;
}

.progress-container {
  margin-top: 15px;
}

.progress-item {
  margin-bottom: 15px;
}

.progress-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}

/* 移动端样式 */
.sidebar-toggle {
  position: absolute;
  top: 10px;
  right: -15px;
  width: 30px;
  height: 30px;
  background-color: #7957d5;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.mobile-sidebar {
  position: fixed;
  z-index: 90;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar-collapsed {
  width: 64px;
}

.sidebar-collapsed .sidebar-title,
.sidebar-collapsed .progress-section {
  display: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .mobile-only {
    display: block !important;
  }
  
  .sidebar {
    width: 240px;
  }
  
  .sidebar-collapsed {
    width: 64px;
  }
}

@media (min-width: 769px) {
  .mobile-only {
    display: none !important;
  }
}
</style>
